import SvgIcon from '@mui/material/SvgIcon';
import { BRIGHT_BLUE } from 'utils/theme';

const RadioFilledIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontSize: props.width ?? '18px',
      }}
    >
      <path
        d="M1 8.25C1 12.3921 4.35786 15.75 8.5 15.75C12.6421 15.75 16 12.3921 16 8.25C16 4.10786 12.6421 0.75 8.5 0.75C4.35786 0.75 1 4.10786 1 8.25Z"
        stroke={BRIGHT_BLUE}
        strokeOpacity="0.6"
        fill="none"
      ></path>
      <path
        d="M3.9375 8.25C3.9375 10.7698 5.9802 12.8125 8.5 12.8125C11.0198 12.8125 13.0625 10.7698 13.0625 8.25C13.0625 5.7302 11.0198 3.6875 8.5 3.6875C5.9802 3.6875 3.9375 5.7302 3.9375 8.25Z"
        fill={BRIGHT_BLUE}
      ></path>
    </SvgIcon>
  );
};

export default RadioFilledIcon;
